import React, { useEffect, useRef, useState } from 'react';
import { Button, Form, Figure } from 'react-bootstrap';

import { makeUID } from '../../../helpers';
import useAPI from '../../../hooks/useAPI';
import useToast from '../../../hooks/useToast';

export default function NewsEditImageSelect({
  postId, file, setFile, markToDelete, setMarkToDelete, imageFileId, link
}) {
  const api = useAPI();
  const addToast = useToast();
  const inputRef = useRef(null);
  const handleUpload = () => inputRef.current?.click();

  const [uploadInputKey, setUploadInputKey] = useState(makeUID(5));
  const [backendPreview, setBackendPreview] = useState();
  const [localPreview, setLocalPreview] = useState();

  useEffect(async () => {
    if (imageFileId && (link || postId !== 'new')) {
      const resp = await api.get(link || `/news/${postId}/image`, true);
      const blob = await resp.blob();
      const objectUrl = URL.createObjectURL(blob);
      setBackendPreview(objectUrl);

      return () => URL.revokeObjectURL(objectUrl);
    }
  }, [imageFileId, link]);

  useEffect(async () => {
    if (!file) {
      setLocalPreview(undefined);
      return;
    }

    const objectUrl = URL.createObjectURL(file);
    setLocalPreview(objectUrl);

    return () => URL.revokeObjectURL(objectUrl);
  }, [file]);

  const handleFileChange = (event) => {
    if (event && event.target) {
      const { target } = event;
      const fileToSet = target.files.length ? target.files[0] : null;

      if (fileToSet.size > 2 * 1024 * 1024) {
        addToast.error('Не удалось выбрать файл - размер превышает 2 Мбайта');
        return;
      }

      setFile(fileToSet);
    } else {
      setFile(null);
      setUploadInputKey(makeUID(5));
    }
  };

  return (
    <>
      <Form.Control accept=".png, .jpg, .jpeg" ref={inputRef} key={uploadInputKey} onChange={handleFileChange} type="file" className="d-none" />
      { file && (
        <div className="mt-3">
          <Figure.Image height="250" width="250" src={localPreview} alt="Предпросмотр загруженного изображения" />
          <Button onClick={() => handleFileChange(null)} variant="light" className="btn-close" size="sm" />
        </div>
      )}
      { !file && !markToDelete && backendPreview && (
      <div className="mt-3">
        <Figure.Image height="250" width="250" src={backendPreview} alt="Предпросмотр загруженного изображения" />
        <Button onClick={() => setMarkToDelete(true)} variant="light" className="btn-close" size="sm" />
      </div>
      )}
      {(file || markToDelete) && (
        <div style={{ color: 'red', marginBottom: '10px' }}>
          {file
            ? 'Необходимо сохранить изменения, чтобы загрузить файл. '
            : 'Необходимо сохранить изменения, чтобы удалить файл. '}
          {markToDelete && !file && <a href="javascript:void(0)" onClick={() => setMarkToDelete(false)}>Отменить удаление</a>}
        </div>
      )}
      { (!file || markToDelete) && (<Button onClick={handleUpload}>Выбрать файл</Button>) }
    </>
  );
}
